module.exports = __webpack_public_path__ + "media/images/icons/close-blue-e6ed83f4125c4786cec49a04a824ca5d.svg";